module.exports = __webpack_public_path__ + "static/media/gpcl_v2.a8bb2a02.png";